import React from "react";

import { connect } from "react-redux";
import UsersByRole from "./Graphs/UsersByRole";
import Margin from "Components/Stats/Margin";
import UsersTable from "Components/Stats/Tables/UsersTable";
import PropTypes from "prop-types";
import UsersByCharterSigned from "./Graphs/UsersByCharterSigned";
import UsersByProfile from "./Graphs/UsersByProfile";
import UsersCountByRegistrationDate from "./Graphs/UsersCountByRegistrationDate";
import UsersCountByMonth from "./Graphs/UsersCountByMonth";

/**
 * Composant UtilisateursModule sert à afficher les graphiques de la partie utilisateurs
 * à l'aide de la librairie Nivo, et de composants génériques créés à partir de
 * cette librairie.
 *
 * Les données formatées des graphiques proviennent du dossier Data (dont les fonctions reçoivent les données API)
 *
 * La liste des graphiques :
 * - Nombre d'utilisateurs par rôle (camembert) : {@link UsersByRole}
 * - Nombre d'utilisateurs par date d'inscription (barres) : {@link UsersCountByRegistrationDate}
 * - Nombre d'utilisateurs par profil (camembert) : {@link UsersByProfile}
 * - Nombre d'utilisateurs ayant signé la charte RéseauPro (camembert) : {@link UsersByCharterSigned}
 * - Tableau récapitulatif des utilisateurs : {@link UsersTable}
 */
const UtilisateursModule = (props) => {
  const currentUniversity = props.auth.universityConnected || "A";

  return (
    <div className="stats_container">
      <UsersCountByMonth universityName={currentUniversity.name} />
      <UsersByRole universityName={currentUniversity.name} />
      <UsersCountByRegistrationDate universityName={currentUniversity.name} />
      <Margin position="bottom" size="" />
      <UsersByProfile universityName={currentUniversity.name} />
      <Margin position="bottom" size="" />

      <Margin position="bottom" size="" />
      {/* Graphique affichant la part d'utilisateurs ayant refusé / validé la charte RéseauPro */}
      <UsersByCharterSigned universityName={currentUniversity.name} />
      <Margin position="bottom" size="" />
      <Margin position="bottom" size="" />
      <UsersTable />
      <Margin position="bottom" size="s" />
    </div>
  );
};

UtilisateursModule.propTypes = {
  users: PropTypes.any,
  auth: PropTypes.any,
};

const mapStateToProps = (state) => ({
  users: state.users,
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UtilisateursModule);
